import React, { FC } from "react";

import { FullscreenFallback } from "../DialogComponents/DialogFallback/FullscreenFallback";
import { useContext } from "./hooks/useContext";

export const GeometrySelection: FC = () => {
  const context = useContext();

  return <FullscreenFallback context={context} />;
};
